/* Expandable content */
$(function () {
  $('[data-expand-toggle]').each(function (i, e) {
    let group = $(e).data('expand-toggle'),
        content = $('[data-expand-toggle="' + group + '"], [data-expand-content="' + group + '"]'),
        closed = true;
    content.addClass('closed');
    $(e).click(function () {
      if (closed) {
        closed = false;
        content.removeClass('closed');
      } else {
        closed = true
        content.addClass('closed');
      }
    });
  });
  $('[data-expand-active]').click();
});
